import React, { useState } from 'react';
import './ProductSpecificationTabs.css';

const ProductSpecificationTabs = ({ product }) => {
  const [activeTab, setActiveTab] = useState('description');

  const tabs = [
    { id: 'description', label: 'Description', icon: 'fas fa-file-text' },
    { id: 'specifications', label: 'Specs', icon: 'fas fa-cogs' },
    { id: 'delivery', label: 'Delivery', icon: 'fas fa-shipping-fast' },
    { id: 'returns', label: 'Returns', icon: 'fas fa-exchange-alt' }
  ];

  const renderDescription = () => (
    <div className="tab-content">
      <h4>Product Description</h4>
      <div className="description-content">
        {product.product_description || product.description || 'No description available for this product.'}
      </div>
      
      {product.key_features && (
        <div className="key-features">
          <h5>Key Features</h5>
          <ul>
            {product.key_features.split(',').map((feature, index) => (
              <li key={index}>{feature.trim()}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  const renderSpecifications = () => (
    <div className="tab-content">
      <h4>Product Specifications</h4>
      <div className="specifications-grid">
        {product.brand && (
          <div className="spec-row">
            <span className="spec-label">Brand:</span>
            <span className="spec-value">{product.brand}</span>
          </div>
        )}
        
        {product.category && (
          <div className="spec-row">
            <span className="spec-label">Category:</span>
            <span className="spec-value">{product.category}</span>
          </div>
        )}
        
        {product.subcategory && (
          <div className="spec-row">
            <span className="spec-label">Sub Category:</span>
            <span className="spec-value">{product.subcategory}</span>
          </div>
        )}
        
        {product.color && (
          <div className="spec-row">
            <span className="spec-label">Color:</span>
            <span className="spec-value">{product.color}</span>
          </div>
        )}
        
        {product.size && (
          <div className="spec-row">
            <span className="spec-label">Size:</span>
            <span className="spec-value">{product.size}</span>
          </div>
        )}
        
        {product.weight && (
          <div className="spec-row">
            <span className="spec-label">Weight:</span>
            <span className="spec-value">{product.weight} kg</span>
          </div>
        )}
        
        {product.material && (
          <div className="spec-row">
            <span className="spec-label">Material:</span>
            <span className="spec-value">{product.material}</span>
          </div>
        )}
        
        {product.warranty && (
          <div className="spec-row">
            <span className="spec-label">Warranty:</span>
            <span className="spec-value">{product.warranty}</span>
          </div>
        )}
        
        {product.model_number && (
          <div className="spec-row">
            <span className="spec-label">Model Number:</span>
            <span className="spec-value">{product.model_number}</span>
          </div>
        )}
        
        {product.hsn_code && (
          <div className="spec-row">
            <span className="spec-label">HSN Code:</span>
            <span className="spec-value">{product.hsn_code}</span>
          </div>
        )}
        
        {product.country_of_origin && (
          <div className="spec-row">
            <span className="spec-label">Country of Origin:</span>
            <span className="spec-value">{product.country_of_origin}</span>
          </div>
        )}
        
        {/* Dimensions */}
        {(product.length || product.breadth || product.height) && (
          <div className="spec-row">
            <span className="spec-label">Dimensions:</span>
            <span className="spec-value">
              {product.length || 0} x {product.breadth || 0} x {product.height || 0} cm
            </span>
          </div>
        )}
      </div>
    </div>
  );

  const renderDeliveryInfo = () => (
    <div className="tab-content">
      <h4>Delivery Information</h4>
      
      <div className="delivery-info">
        <div className="delivery-item">
          <i className="fas fa-truck"></i>
          <div>
            <h5>Standard Delivery</h5>
            <p>Free delivery on orders above ₹1000</p>
            <p>Delivery charges: ₹50 for orders below ₹1000</p>
          </div>
        </div>
        
        <div className="delivery-item">
          <i className="fas fa-clock"></i>
          <div>
            <h5>Delivery Time</h5>
            <p>3-7 business days for most locations</p>
            <p>May take longer for remote areas</p>
          </div>
        </div>
        
        <div className="delivery-item">
          <i className="fas fa-map-marker-alt"></i>
          <div>
            <h5>Delivery Coverage</h5>
            <p>Available across India</p>
            <p>Cash on Delivery available</p>
          </div>
        </div>
        
        {product.weight && (
          <div className="delivery-item">
            <i className="fas fa-weight-hanging"></i>
            <div>
              <h5>Package Weight</h5>
              <p>{product.weight} kg</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const renderReturnsExchange = () => (
    <div className="tab-content">
      <h4>Returns & Exchange Policy</h4>
      
      <div className="policy-info">
        <div className="policy-item">
          <i className="fas fa-undo"></i>
          <div>
            <h5>7 Days Return Policy</h5>
            <p>Easy returns within 7 days of delivery</p>
            <p>Product should be in original condition</p>
          </div>
        </div>
        
        <div className="policy-item">
          <i className="fas fa-exchange-alt"></i>
          <div>
            <h5>Exchange Available</h5>
            <p>Size and color exchange available</p>
            <p>Subject to availability</p>
          </div>
        </div>
        
        <div className="policy-item">
          <i className="fas fa-money-bill-wave"></i>
          <div>
            <h5>Refund Process</h5>
            <p>Refund processed within 5-7 business days</p>
            <p>Amount credited to original payment method</p>
          </div>
        </div>
        
        <div className="policy-item">
          <i className="fas fa-ban"></i>
          <div>
            <h5>Non-Returnable Items</h5>
            <p>Personal care items</p>
            <p>Customized products</p>
            <p>Perishable goods</p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'description':
        return renderDescription();
      case 'specifications':
        return renderSpecifications();
      case 'delivery':
        return renderDeliveryInfo();
      case 'returns':
        return renderReturnsExchange();
      default:
        return renderDescription();
    }
  };

  return (
    <div className="product-specification-tabs">
      <div className="tabs-header">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <i className={tab.icon}></i>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>
      
      <div className="tabs-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default ProductSpecificationTabs;
